import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { HStack } from '~/components/elements/HStack'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'

import { type InputValues } from '../utils'

import { ConditionGroupCopier } from './ConditionGroupCopier'
import { ConditionGroupInput } from './ConditionGroupInput'

export type ConditionGroupsInputProps = {
  nineSegmentIndex: number
}

export const ConditionGroupsInput = ({
  nineSegmentIndex,
}: ConditionGroupsInputProps) => {
  const { t } = useTranslation()
  const { control } = useFormContext<InputValues>()
  const { append, fields, remove } = useFieldArray({
    control,
    keyName: 'fieldId',
    name: `segment_definitions.${nineSegmentIndex}.condition_groups`,
  })

  const handleAddButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    append([[]])
  }, [append])

  return (
    <VStack spacing={4}>
      {fields.map((field, conditionGroupIndex) => (
        <React.Fragment key={field.fieldId}>
          {conditionGroupIndex !== 0 && (
            <Typography fontSize={16} variant="normal">
              Or
            </Typography>
          )}

          <ConditionGroupInput
            conditionGroupIndex={conditionGroupIndex}
            nineSegmentIndex={nineSegmentIndex}
            onDelete={remove}
          />
        </React.Fragment>
      ))}

      <HStack justify="space-between" spacing={4}>
        <StyledButton onClick={handleAddButtonClick}>
          {t('add_definition_group')}
        </StyledButton>

        <ConditionGroupCopier nineSegmentIndex={nineSegmentIndex} />
      </HStack>
    </VStack>
  )
}
